import { Dispatch } from "redux";
import { loadAndTrack } from "redux-request-loading";
import { orderBy } from "lodash";

import { Payload } from "@neworbit/redux-helpers";

import axios from "axios";

import * as actions from "./actiontypes";
import * as models from "./model";
import { textSnippetApi } from "./textSnippetApi";

export type TextSnippetAction = ({ type: typeof actions.LOAD_TEXTSNIPPETS_SUCCESS } & Payload<models.TextSnippetListModel[]>)

export const loadTextSnippetsSuccess = (payload: models.TextSnippetListModel[]): TextSnippetAction => ({
    payload,
    type: actions.LOAD_TEXTSNIPPETS_SUCCESS
});

export function loadTextSnippets(filter?: models.TextSnippetFilter) {
    return async (dispatch: Dispatch) => {
        try {
            const result = await loadAndTrack(dispatch, actions.LOAD_TEXTSNIPPETS, textSnippetApi.getAll(filter));
            const orderedResult = orderBy(result, snippet => snippet.name.toLowerCase());
            dispatch(loadTextSnippetsSuccess(orderedResult));
        } catch (ex) {
            if (!(ex instanceof axios.Cancel)) { // eslint-disable-line import/no-named-as-default-member
                throw ex;
            }
        }
    };
}
